// Internally used component to format choices
import styles from './index.module.less';
import ChoiceFormatter from '../ChoiceFormatter/ChoiceFormatter';

function HVSelect({ meta, helpers, className, ...props }) {
    const classNameCalculated = [
        'ant-input',
        'ant-input-lg',
        styles['select'],
        className
    ].join(' ');
    return <ChoiceFormatter className={classNameCalculated} {...props} />;
}

export default HVSelect;
